const slugs = {
  jack: "/jack",
  // bingo: " /bingo",
  shake: "/shake",
  bingo: "/bingo",
};
export default slugs;
